import TextHighlighter from 'containers/NewReviewed/components/TextHighlighter';
import styles from './SimplifiedFeedbackText.module.scss';

interface SimplifiedFeedbackTextProps {
  paragraphs: string[];
}

function SimplifiedFeedbackText({
  paragraphs,
}: SimplifiedFeedbackTextProps): JSX.Element {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>O texto que você escreveu</h2>

      {/* Container com overflow/scroll próprio precisa ser alcançável por teclado quando o
      texto excede o max-height — exceção reconhecida do WCAG (scrollable region pattern) que a
      regra padrão do jsx-a11y não conhece. */}
      {/* eslint-disable jsx-a11y/no-noninteractive-tabindex */}
      <div
        className={styles.textScroll}
        tabIndex={0}
        role="region"
        aria-label="Texto da redação"
      >
        {/* eslint-enable jsx-a11y/no-noninteractive-tabindex */}
        <TextHighlighter newParagraphs={paragraphs} highlights={[]} />
      </div>
    </div>
  );
}

export default SimplifiedFeedbackText;
